// extracted by mini-css-extract-plugin
export default {"bgd":"style_bgd__qIIrp","open":"style_open__TddN+","pwindow":"style_pwindow__PNtr6","window":"style_window__+K+YH","closeIcon":"style_closeIcon__3pMBo"};